import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';

interface SaveIconProps extends IconWrapperProps {
  color?: string;
  fill?: string;
}

const SaveIcon = ({ color = 'currentColor', fill, ...rest }: SaveIconProps) => (
  <IconWrapper viewBox="0 0 21 24" width="21" height="24" {...rest}>
    <path
      stroke={color}
      fill={fill}
      strokeWidth="2"
      d="m10.872 16.269-.597-.443-.596.443-8.404 6.242V3.167c0-.85.772-1.667 1.858-1.667h14.285c1.085 0 1.857.816 1.857 1.667V22.51l-8.403-6.242Z"
    />
  </IconWrapper>
);

export default SaveIcon;
